<template>
	<div id="landing-imprint" class="landing-text-grid">
		<p class="content-description light-text" v-html="imprintText"></p>
	</div>
</template>

<script>

import JsonProvider from '../../../services/DataService.js';
import {MarkdownProvider} from '../../../services/DataService.js';

	export default {
		name: 'LandingImprint',
		components: {
		},
		data: function() {
			return {
				imprintText: "",
				imprintData: [],
		}
	},
	
		created: async function() {
			var jsonGetter = new JsonProvider();
			var data = await jsonGetter.fetchJsonObject('page-texts');
			var mdp = new MarkdownProvider();

			this.imprintData = data.find(el => el.name == "impressum");
			this.imprintText = mdp.convertMarkdown(this.imprintData.text);
	}
}

</script>

<style scoped>
	#landing-imprint {
		margin: auto;
		margin-top: 5em;
	}

	@media (max-width: 991px) {
		#landing-imprint {
			margin-top: 6em;
		}
	}
</style>